import React, {useContext, useState} from 'react';
import {ru} from "../data/ru";
import {by} from "../data/by";
import Context from "../context";
import API from "../API";
import ErrorMessage from "../authorization/errorMessage";
import style from "./auth.module.css";

const AuthForm = () => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.authorization : by.authorization
    const {mainState, logIn} = useContext(Context)
    const [form, setForm] = useState({login: '', password: ''});
    const [error, setError] = useState('');

    const changeHandler = event => {
        setForm({...form, [event.target.name]: event.target.value});
    }

    const loginHandler = () => {
        const api = new API()
        api.authorization(form.login, form.password, logIn, setError)
    }


    const pass = !(error === 'Неверный пароль') ? <ErrorMessage/> : <ErrorMessage
        error={error === 'Неверный пароль' ? 'Неверный пароль' : 'При обращении к серверу произошла ошибка'}/>;
    const log = !(error === 'Неверный логин') ? <ErrorMessage/> : <ErrorMessage
        error={error === 'Неверный логин' ? 'Неверный логин' : 'При обращении к серверу произошла ошибка'}/>;

        return (
                    <form className={style.formContainer} onSubmit={e => e.preventDefault()}>
                        <div className={style.authForm}>
                            <div className={style.authTitle}>
                                <p>{language.authorizationTitle}</p>
                            </div>
                            <div>
                                <input type="text" placeholder={language.enterLogin} name="login"
                                       onChange={changeHandler}
                                       required/>
                                <div className={style.textError}>{log}</div>
                            </div>
                            <div>
                                <input type="password" placeholder={language.enterPassword} name="password"
                                       onChange={changeHandler} required/>
                                <div className={style.textError}>{pass}</div>
                            </div>
                        </div>
                        <button type="submit" onClick={loginHandler}>{language.button}</button>
                    </form>
        )
};

export default AuthForm;